import { STOModel } from "../../models/base/sto-model";
import { EmployeeApproversDTO } from "../../models/employee-approver/employee-approver-dto";
import { BaseApiService } from "../base";

export class EmployeesApproversOverviewApiService extends BaseApiService<EmployeeApproversDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/Employees",
      loadItemsPath: "/GetEmployeesApproversOverview",
    });
  }
}
